import {observable, action, runInAction, makeObservable} from 'mobx';
import browserLang from 'browser-lang';
import {Dispatcher, LanguageManager} from '@yosmanyga/base';
import {decorate, inject, injectable} from '@yosmanyga/di';

class WithLanguageController {
    loaded: boolean;
    language: string | undefined;

    constructor(
        private dispatcher: Dispatcher,
        private languageManager: LanguageManager
    ) {
        this.loaded = false;
        this.language = undefined;

        this.dispatcher.register('language_saved', this.listenToLanguageSaved);

        makeObservable(this, {
            loaded: observable,
            language: observable,
            load: action,
            listenToLanguageSaved: action
        });
    }

    load = async () => {
        await this.languageManager.load();

        runInAction(() => {
            try {
                this.language = this.languageManager.get()
                    || browserLang({
                        languages: ['en', 'es'],
                        fallback: 'en',
                    });
            } catch (e) {
                this.language = 'en';
            }
            
            this.loaded = true;
        });
    };

    listenToLanguageSaved = (language: string) => {
        runInAction(() => {
            this.language = language;
        });
    };
}

decorate(injectable(), WithLanguageController);
decorate(inject(Dispatcher), WithLanguageController, 0);
decorate(inject(LanguageManager), WithLanguageController, 1);

export {WithLanguageController};
